export const getTotal = (val = {}) => {
  const getQty = parseFloat(val?.qty_realisasi ?? 0);
  const getPrice = parseFloat(val?.harga_satuan ?? 0);

  return getQty * getPrice;
};
